import { Link } from 'react-router-dom';
import styles from './LoginOrRegisterFixcenter.module.scss';
import { getPdfFileUrl } from '../../shared/services/local-document.service';
import { useTranslation } from '../../i18n/useTranslation';

export default function LoginOrRegisterFixcenter() {
    const { t } = useTranslation('translation');

    const downloadPdf = () => {
        window.open(getPdfFileUrl('fixcenter7.pdf'), '_blank');
    };

    return (
        <div className={styles.container}>
            <div className={styles.row}>
                <div className={styles.title}>
                    {t('header.LOGIN_OR_CREATE_ACCOUNT_FOR_ONLINE_WEBSHOP')}
                </div>
                <div className={styles.btns_container}>
                    <Link className={styles.btn} to="/login">{t('LOGIN')}</Link>
                    <Link className={styles.btn} to="/register">{t('CREATE_ACCOUNT')}</Link>
                </div>

            </div>
            <div className={styles.row}>
                <div className={styles.title}>
                    {t('header.SEE_OUR_CATALOG_PDF')}
                </div>
                <button 
                    className={styles.btn}
                    onClick={() => downloadPdf()}>
                    {t('GO_TO_CATALOG')}
                </button>
            </div>
        </div>
    )
}